import { render, staticRenderFns } from "./EditGrantRegistreUser.vue?vue&type=template&id=39f600f9&scoped=true&"
import script from "./EditGrantRegistreUser.ts?vue&type=script&lang=ts&"
export * from "./EditGrantRegistreUser.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f600f9",
  null
  
)

export default component.exports
import {QToggle} from 'quasar'
component.options.components = Object.assign({QToggle}, component.options.components || {})
